<template>
  <!-- Footer -->
  <mdb-footer color="blue" class="font-small pt-4 mt-4">
    <mdb-container class="text-left">
      <mdb-row>
        <mdb-col sm="6">
          <h5 class="title">Adresse</h5>
          <p>AMERICAN CLASSICS LLC <br />
3441 21st Ave. SW <br />
Naples, Florida 34117 


</p>
        </mdb-col>
        <mdb-col sm="6">
          <h5 class="title">Kontakt</h5>
          <ul>
            <li class="list-unstyled"><a href="#!">Tel. 001-305-505-2052</a></li>
            <li class="list-unstyled"><a href="#!">www.amclass-autotransport.com</a></li>
            <li class="list-unstyled"><a href="#!">info@amclass-autotransport.com</a></li>
          </ul>
        </mdb-col>
      </mdb-row>
    </mdb-container>
    <div class="footer-copyright text-center py-3">
      <mdb-container fluid>
        &copy; 2019 Copyright: <a href="http://www.amclass-autotransport.com"> amclass-autotransport.com </a>
      </mdb-container>
    </div>
  </mdb-footer>
  <!-- Footer -->
</template>
<script>
  import { mdbFooter, mdbContainer, mdbRow, mdbCol } from 'mdbvue';
  export default {
    name: 'footerpage',
    components: {
      mdbFooter,
      mdbContainer,
      mdbRow,
      mdbCol
    }
  }
</script>